//odemeok
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useTranslation } from 'react-i18next';

export const Packages = () => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);



    useEffect(() => {
    }, []);

    return (
        <div className="row">
            {msg}
            ödeme hata
        </div>
    )
}
export default Packages;